import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { WPQTCard } from "../../../../../components/Card/Card";
function NotificationItem({ notification }) {
    const navigate = useNavigate();
    const onClick = () => {
        if (notification.type === "task") {
            navigate(`/tasks/${notification.subjectHash}/comments`);
        }
        else {
            navigate(`/user/comments`);
        }
    };
    return (_jsx(WPQTCard, { title: notification.subjectName, onClick: onClick, className: "wpqt-cursor-pointer", children: _jsxs("div", { children: [notification.numberOfComments, " new comments"] }) }));
}
export { NotificationItem };
